import { IconX } from '@tabler/icons-react';
import _debounce from 'lodash/debounce';
import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { getApi, postApi } from '../../../api/call.api';
import { urlApi } from '../../../api/url.api';
import ShortLinkDropdown from '../../../components/DropDown/ShortLinkDropdown';
import { loadingHide, loadingShow } from '../../../loadingUi/loading.controller';

const CreatePageLinkModal = () => {
    const navigate = useNavigate();
    const [show, setShow] = useState(false);
    const [customBackResp, setCustomBackResp] = useState(null);
    const [templates, setTemplates] = useState([]);
    const [selectedTemplate, setSelectedTemplate] = useState(null);

    const handleClose = () => {
        setCustomBackResp(null);
        setSelectedTemplate(null);
        setShow(false)
    };
    const handleShow = () => {
        getTemplates();
    };

    const submit = async () => {
        if (document.getElementById('linkCode').value?.trim()) {
            loadingShow();
            let postData = {
                linkCode: document.getElementById('linkCode').value?.trim(),
            }
            if (selectedTemplate) {
                postData.templateCode = selectedTemplate;
            }
            let resp = await postApi(postData, urlApi.createPageLink);
            loadingHide();
            if (resp.responseCode === 200) {
                navigate('/create-page/' + resp?.data);
                handleClose();
            } else {
                toast.error(resp.message);
            }
        } else {
            toast.error('Please enter a name');
        }
    }

    const checkCustomBackHalf = async (e) => {
        let postData = {
            "linkCode": e.target.value?.trim(),
        }
        if (e.target.value?.length >= 3) {
            let resp = await postApi(postData, urlApi.checkCustomBackHalf);
            setCustomBackResp(resp);
        } else if (e.target.value?.length == 0) {
            setCustomBackResp(null);
        }
    }

    const getTemplates = async () => {
        loadingShow();
        let resp = await getApi(urlApi.templateList);
        setShow(true);
        loadingHide();
        if (resp?.responseCode === 200) {
            setTemplates(resp.data);
        } else {
            setTemplates([])
        }
    }

    const handleSelectTemplate = (template) => {
        setSelectedTemplate(
            selectedTemplate == template ? null : template
        );
    }

    return (
        <>
            <button className='primary-btn' onClick={handleShow}>Create Page</button>
            <Modal show={show} onHide={handleClose} size='lg' backdrop="static">
                <Modal.Body className='rounded-xl'>
                    <div className="flex justify-between items-center">
                        <p className="text-md font-semibold mb-0">Create Page</p>
                        <IconX className='cursor-pointer' onClick={handleClose} />
                    </div>
                    <hr className='my-3' />

                    <p className="text-sm text-center text-[var(--secondary-text)] !mb-3">Build a beautiful page to share and manage all the links that matter to you. <br /> Attriva powers hundreds of thousands of pages for creators and businesses of all kinds. </p>

                    <p className="text-[15px] font-semibold mb-1">Claim your URL</p>
                    <div className="flex flex-wrap md:flex-nowrap">
                        <div className='mb-3 w-full md:w-[50%] px-2'>
                            <ShortLinkDropdown isTitle={false} />
                        </div>
                        <div className='mb-3 w-full md:w-[50%] px-2'>
                            <input type='text' id='linkCode' className='w-full px-3 py-2 rounded-md border-2 text-sm' placeholder='Your name / Business (Minimum 3 Character)' onChange={_debounce((e) => checkCustomBackHalf(e), 300)} />
                            <p className="mb-0 text-xs text-gray-500">
                                *Minimum 3 characters, including alphanumeric and special (only ' - ' , ' _ ') characters.
                            </p>
                            {
                                customBackResp &&
                                <div className={`text-xs ps-1 ${customBackResp?.responseCode == 200 ? "text-green-700" : 'text-red-700'}`}>{customBackResp?.message}</div>
                            }
                        </div>
                    </div>
                    <p className="text-[15px] font-semibold mb-2">Choose A Template (Optional)</p>

                    <Swiper
                        style={{ paddingBottom: 30 }}
                        spaceBetween={20}
                        slidesPerView={5}
                        className=''
                        loop={true}
                        autoplay={{ delay: 3500, disableOnInteraction: true }}
                        pagination={true}
                        navigation={true}
                        modules={[Pagination, Autoplay, Navigation]}
                        breakpoints={{
                            430: {
                                slidesPerView: 2,
                            },
                            576: {
                                slidesPerView: 3,
                            },
                            1000: {
                                slidesPerView: 5,
                            }
                        }}
                    >
                        {
                            templates?.map((item, i) => {
                                return (
                                    <SwiperSlide key={item?._id}>
                                        <div className={`rounded-lg p-1 cursor-pointer ${selectedTemplate == item?.pageCode && ' border-2 border-primary shadow-md'}`} onClick={() => handleSelectTemplate(item?.pageCode)}>
                                            <img src={item.pageImage} alt={item.pageCode} className='w-full rounded-lg shadow-md' />
                                        </div>
                                    </SwiperSlide>
                                )
                            })
                        }
                    </Swiper>

                    <hr className='my-3' />
                    <div className='flex justify-between gap-3'>
                        <button className='modal-cancel-btn' onClick={handleClose}>Cancel</button>
                        <button className='primary-btn' onClick={() => submit()}>Create</button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default CreatePageLinkModal